export default __webpack_public_path__ + "static/media/forgot-password.2c7d6296.svg";